import React, {useState} from "react";

import getYoutubeThumbnail from "./lib/getYoutubeThumbnail";

import { Button } from './../buttons/index';

import * as styles from "./styles/card.module.scss";

//Import model
import { Modal } from '../modal';

const CaseStudyCard = props => {
    const {
        title,
        description,
        youtubeVideoId,
        thumbnail
    } = props;
    const [visible, setVisible] = useState(false);
    return (
        <article className={styles.card}>
            <div className={styles.cardWrap} onClick={() => setVisible(true)}>
                <figure>
                    <img src={thumbnail?.publicUrl ? thumbnail?.publicUrl : getYoutubeThumbnail(youtubeVideoId)} alt={title} />
                </figure>
                <div>
                    {title && <h3>{title}</h3>}
                    {description && <p>{description}</p>}
                </div>
                <Button
                    elementType="span"
                    fullWidth={true}
                    colorData="white"
                    typeData="centered"
                    href="#"
                    content="Watch Video"
                    alt="Watch Video" />
            </div>
            <Modal
                setVisible={setVisible}
                visible={visible}
                size="large"
                orientation="landscape">
                <iframe
                    className={styles.modalCardIframe}
                    title={title}
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${youtubeVideoId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen />
            </Modal>
</article>
    )
}

export default CaseStudyCard;
